<template>
  <div class="row no-gutters text-center" style="height: 80vh; overflow-y: auto">
    <div class="col-12">
      <div style="background: #e1e1e1; position: sticky; top: 0;">
        <table class="small e-tbl">
          <thead class="bg-white" style="position: sticky; top: 0; z-index: 2">
          <tr>
            <th style="width: 15%">Vessel Name</th>
            <th style="width: 15%">Report Date</th>
            <template v-if="company_instructions[0]?.children !== undefined && company_instructions[0]?.children.length > 0 ">
              <template v-if="company_instructions[0]?.code.includes('RS')">
                <th style="width: 15%">Finding</th>
                <th style="width: 15%">Description of Finding</th>
                <th style="width: 15%">Type of Finding</th>
              </template>
              <template v-else>
                <th style="width: 15%">Deficiency Code</th>
                <th style="width: 15%">Deficiency Description</th>
                <th style="width: 15%">Action Code</th>
              </template>
            </template>
            <template v-else-if="company_instructions[0]?.ci_type === 'ia'">
              <th style="width: 15%">Management Office</th>
              <th style="width: 15%">Title</th>
              <th style="width: 15%">Category</th>
            </template>
            <template v-else>
              <th style="width: 15%">Management Offices</th>
              <th style="width: 15%">Title</th>
              <th style="width: 15%">Code</th>
            </template>
            <th style="width: 7%"></th>
          </tr>
          </thead>
        </table>
      </div>
      <template v-if="company_instructions">
          <template v-if="Array.isArray(company_instructions) ">
            <template v-for="(instruction, index) in company_instructions">
              <table class="small table table-sm table-borderless mb-0" style="margin-top: 1rem;">
                <tbody>
                <tr style="cursor: pointer" @click="toggleAccordion(index)">
                  <td style="width: 15%;font-size: 13px;" class="align-middle">

                      <span style="position: absolute; left: 10px; z-index: -100">
                        <font-awesome-icon v-if="CIactivetrees.includes(index)" icon="chevron-down"/>
                        <font-awesome-icon v-else icon="chevron-right"/>
                      </span>
                      <strong>
                        {{ instruction.vessel | toUpper }}
                      </strong>


                  </td>
                  <td style="width: 15%; font-size: 13px" class="align-middle"><strong>{{ instruction.date }}</strong></td>
                  <template v-if="instruction?.children !== undefined && instruction?.children?.length > 0">
                    <td style="width: 15%; font-size: 13px" class="align-middle">({{ instruction.children[0].code }}) {{ instruction.children[0].code_description }}</td>
                    <td style="width: 15%; font-size: 13px" class="align-middle" v-html="instruction.children[0].desription"></td>
                    <td style="width: 15%; font-size: 13px" class="align-middle" v-if="company_instructions[0]?.code.includes('RS')">{{ instruction.type_of_finding }}</td>
                    <td style="width: 15%; font-size: 13px" class="align-middle" v-else>({{ instruction.children[0].action_code }}) {{ instruction.children[0].action_code_description }}</td>
                  </template>

                    <template v-else-if="company_instructions[0]?.ci_type === 'ia'">
                    <td style="width: 15%; font-size: 13px" class="align-middle">{{ instruction.mangement_office | toUpper }}</td>
                    <td style="width: 15%; font-size: 13px" class="align-middle">{{ instruction.title | toUpper }}</td>
                    <td style="width: 15%; font-size: 13px" class="align-middle">{{ instruction.category }}</td>
                  </template>

                  <template v-else>
                    <td style="width: 15%; font-size: 13px" class="align-middle">{{ instruction.mangement_office | toUpper }}</td>
                    <td style="width: 15%; font-size: 13px" class="align-middle">{{ instruction.title | toUpper }}</td>
                    <td style="width: 15%; font-size: 13px" class="align-middle">{{ instruction.code }}</td>
                  </template>

                  <td style="width: 7%" class="align-middle">
                    <button class="e-btn e-btn-blue e-btn-sm e-text-white my-1" @click.stop="redirectTree(instruction)">
                      <font-awesome-icon icon="eye"/>
                      View
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
              <hr >
              <company-instruction-sub-tree v-if="CIactivetrees.includes(index)" :key="instruction.id" :is-shown="showInfo" @viewInstruction="viewInstruction" :node="instruction"></company-instruction-sub-tree>
            </template>
          </template>
          <template v-else>
            <table class="small table table-sm table-borderless w-75 mb-0">
              <tbody>
              <tr>
                <td style="width: 20em" class="align-middle">{{ company_instructions.vessel | toUpper }}</td>
                <td style="width: 20em" class="align-middle">{{ company_instructions.mangement_office | toUpper }}</td>
                <td style="width: 20em" class="align-middle">{{ company_instructions.title | toUpper }}</td>
                <td style="width: 10em" class="align-middle">{{ company_instructions.date }}</td>
                <td style="width: 10em" class="align-middle">
                  <button class="e-btn e-btn-blue e-btn-sm e-text-white my-1" @click.stop="redirectTree(company_instructions)">
                    <font-awesome-icon icon="eye"/>
                    View
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
            <company-instruction-sub-tree :is-shown="showInfo" @viewInstruction="viewInstruction" :node="company_instructions"></company-instruction-sub-tree>
          </template>
      </template>
    </div>

    <CIModal id="view-instruction" :key="'view-instruction'" style="overflow: auto">
      <template v-slot:header>
        <div class="row px-2 align-items-center">
          <div class="col-auto">
            <template v-if="instruction.taggable_is_confidential">
              <router-link v-if="instruction.taggable_deficiency_id && instruction.taggable_code.includes('PSC')"
                           id="exampleModalLongTitle" class="font-weight-normal modal-title pb-0 mr-0 col-10 text-left"
                           :to="{name:'PscMain',params:{id:instruction.taggable_id}}"
                           target="_blank" style="font-size: 15px;">
                <span class="p e-text-black" style="font-size: 15px;">REPORT NO.</span>
                {{ instruction.taggable_code  | toUpper }} - {{ instruction.taggable_title | toUpper }}
              </router-link>

              <router-link v-else-if="instruction.taggable_deficiency_id && instruction.taggable_code.includes('RS')"
                           id="exampleModalLongTitle" class="font-weight-normal modal-title pb-0 mr-0 col-10 text-left"
                           :to="{name:'RsMain',params:{id:instruction.taggable_id}}"
                           target="_blank" style="font-size: 15px;">
                <span class="p e-text-black" style="font-size: 15px;">REPORT NO.</span>
                {{ instruction.taggable_code  | toUpper }} - {{ instruction.taggable_title | toUpper }}
              </router-link>

              <router-link v-else
                           id="exampleModalLongTitle" class="font-weight-normal modal-title pb-0 mr-0 col-10 text-left"
                           :to="{name:'AccidentIncidentReport',params:{id:instruction.taggable_id}}"
                           target="_blank" style="font-size: 15px;">
                <span class="p e-text-black" style="font-size: 15px;">REPORT NO.</span>
                {{ instruction.taggable_code  | toUpper }} - {{ instruction.taggable_title | toUpper }}
              </router-link>
            </template>
            <template v-else>
              <div class="col-10">
                <p class="font-weight-normal modal-title pb-0 mr-0 text-left text-uppercase" style="font-size: 15px;">
                  REPORT NO. {{ instruction.report_code }} - {{ instruction.report_title }} </p>
              </div>
            </template>
          </div>
          <template v-if="user.vessel_id">
            <div class="col-auto">
              <p class="my-0 font-weight-bold">Acknowledgement Status:</p>
            </div>
            <div class="col-auto">
              <template v-if="!!instruction.vessel">
                <button class="ml-0 d-flex align-items-end e-btn e-btn-sm" :class="{
                  'bg-danger':instruction.vessel.cancelled_at,
                  'bg-4c4c4c':!instruction.vessel.cancelled_at && instruction.vessel.acknowledgement_status_id ==1,
                  'bg-042454':!instruction.vessel.cancelled_at && instruction.vessel.acknowledgement_status_id == 2,
                  'bg-42b983':!instruction.vessel.cancelled_at && instruction.vessel.acknowledgement_status_id == 3,
                  'bg-1b4f72':!instruction.vessel.cancelled_at && instruction.vessel.acknowledgement_status_id == 4,
                  'bg-1b4f72':!instruction.vessel.cancelled_at && instruction.vessel.acknowledgement_status_id == 5,
                }">
                  <small class="text-white">{{ instruction.vessel.cancelled_at ? 'CANCELLED' : instruction.vessel.acknowledgement_status }}</small>
                </button>
              </template>
            </div>
            <div class="col-auto">
              <p class="my-0 font-weight-bold">Job Done Status:</p>
            </div>
            <div class="col-auto">
              <template v-if="!!instruction.vessel">
                <button class="ml-0 d-flex align-items-end e-btn e-btn-sm" :class="{
                  'bg-danger':instruction.vessel.cancelled_at,
                  'bg-574e4e':!instruction.vessel.cancelled_at && instruction.vessel.job_status_id ==1,
                  'bg-056cb4':!instruction.vessel.cancelled_at && instruction.vessel.job_status_id ==2,
                  'bg-42b983':!instruction.vessel.cancelled_at && instruction.vessel.job_status_id ==3,
                }">
                  <small class="text-white">{{ instruction.vessel.cancelled_at ? 'CANCELLED' : instruction.vessel.job_status }}</small>
                </button>
              </template>
            </div>
          </template>
        </div>
        <button type="button" class="close ml-0" @click="resetInstruction">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <template v-slot:body>
        <form>
          <div class="row align-items-center mb-2">
            <div class="col-lg-2">
              <h6 class="font-weight-bold">Instruction</h6>
            </div>
            <div class="col-lg-10">
                <input type="text" class="form-control form-control-sm" :value="instruction.title | toUpper"
                       disabled
                       name="instruction_title"
                       id="instruction_title">
            </div>
          </div>
          <div class="row align-items-center mb-2">
            <div class="col-lg-2">
              <h6 class="font-weight-bold">Type of Instruction</h6>
            </div>
            <div class="col-4">
              <input type="text" class="form-control form-control-sm"
                     :value="instruction.instruction_type | toUpper"
                     disabled
                     name="instruction_type"
                     id="instruction_type">
            </div>
          </div>
          <div class="row align-items-center mb-2">
            <div class="col-lg-2">
              <h6 class="font-weight-bold">Related Parties</h6>
            </div>
            <div class="col-lg-4">
              <input type="text" class="form-control form-control-sm"
                     :value="instruction.related_party | toUpper"
                     disabled
                     name="instruction_type"
                     id="instruction_type">
            </div>
          </div>
          <div class="row align-items-center mb-2">
            <div class="col-lg-2">
              <h6 class="font-weight-bold">Instruction Detail</h6>
            </div>
            <div class="col-lg-10 text-left">
              <div id="textArea" class="pre-wrap-txt textarea-display-card" style="min-height: 110px !important;" v-html="instruction.detail || '' " />
            </div>
          </div>

          <template v-if="!user.vessel_id">
            <div class="row align-items-center mb-3">
              <div class="col-2">
                <h6 class="font-weight-bold"> Attachments</h6>
              </div>
              <div class="col-lg-10 text-left">
                <div class="row">
                  <div class="col-2"  v-for="attachment in instructionFiles">
                    <other-comp :no-delete="true"
                                @viewOther="viewInstructionAttachment(attachment,false)"
                                :attachment="attachment" attachment-name="name" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-lg-2">
                <h6 class="font-weight-bold">Vessels</h6>
              </div>
              <div class="col-10">
                <div class="row" style="max-height: 40vh;overflow: auto">
                  <div class="col-12 mb-1 sticky-top" style="background: white; z-index: 1000;">
                    <!-- ROW 1: Action Controls (Filters & Buttons) -->
                    <div class="row align-items-start justify-content-between p-1" style="background-color: #e9ecef">

                      <!-- LEFT SIDE: Vessel, Job, Acknowledgement, Reset -->
                      <div class="d-flex align-items-end flex-wrap" style="gap: 10px;">

                        <!-- 1. Vessel Filter -->
                        <div class="d-flex flex-column">
                          <label class="mb-1 font-weight-bold" style="font-size: 11px;">VESSEL</label>
                          <input type="text" class="form-control form-control-sm" v-model="filters.vessel" @input="setVesselsToTable" style="width: 130px !important;" placeholder="Search Vessel">
                        </div>

                        <!-- 2. Job Completion Filter -->
                        <div class="d-flex flex-column">
                          <label class="mb-1 font-weight-bold" style="font-size: 11px;">JOB COMPLETION</label>
                          <div class="d-flex align-items-center">
                            <div class="input-group position-relative">
                              <select v-model="filters.job" class="form-control form-control-sm text-center" style="width: 110px; padding-left:0; font-size: 12px; height: 31px;" @change="setVesselsToTable">
                                <option style="font-size: 12px;" :value="null" :selected="true">-- ALL --</option>
                                <option style="font-size: 12px;" :value="jobStatus.id" v-for="jobStatus in jobStatuses" :key="jobStatus.id">{{jobStatus.name}}</option>
                                <option style="font-size: 12px;" value="cancelled">CANCELLED</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <!-- 3. Acknowledgement Filter -->
                        <div class="d-flex flex-column">
                          <label class="mb-1 font-weight-bold" style="font-size: 11px;">ACKNOWLEDGEMENT</label>
                          <div class="d-flex align-items-center">
                            <div class="input-group position-relative">
                              <select v-model="filters.acknowledgement" class="form-control form-control-sm text-center" style="width: auto; padding-left:0; font-size: 12px; height: 31px;" @change="setVesselsToTable">
                                <option style="font-size: 12px;" :value="null" :selected="true">-- ALL --</option>
                                <option style="font-size: 12px;" :value="ackStatus.id" v-for="ackStatus in acknowledgementStatuses" :key="ackStatus.id">{{ackStatus.name}}</option>
                                <option style="font-size: 12px;" value="cancelled">CANCELLED</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <!-- 4. Reset Button -->
                        <div class="pb-2">
                          <button class="e-btn-sm e-btn e-btn-blue-gray align-items-end force-white-all" @click="resetPscCompanyInstructionFilter" type="button">
                            <font-awesome-icon class="e-text-white mr-1" icon="filter"/>
                            Reset
                          </button>
                        </div>

                      </div>

                      <!-- RIGHT SIDE: Edit PSC / Save / Cancel -->
                      <div class="d-flex align-items-start pt-1">
                        <div v-if="!isEditCompanyInstructionStatus">
                          <button class="e-btn-sm e-btn e-btn-blue" @click="isEditCompanyInstructionStatus = !isEditCompanyInstructionStatus" v-if="isAllowed('psc.main.deficiency.overview.ci.edit')" type="button">
                            <font-awesome-icon class="e-text-white mr-1" icon="pen"/>
                            Edit status
                          </button>
                        </div>
                        <div v-else class="d-flex align-items-center">
                          <button class="e-btn-sm e-btn e-btn-outlined-red mr-2" type="button" @click="cancelEditAcknowledgementStatus">
                            Cancel
                          </button>
                          <button class="e-btn-sm e-btn e-btn-blue" :class="{'e-btn-blue-disabled':selectedChangeAcknowledgement.length <= 0}" type="button" :disabled="selectedChangeAcknowledgement.length <= 0" @click="bulkSendAcknowledgementStatus">
                            Save
                          </button>
                        </div>
                      </div>

                    </div>

                    <!-- ROW 2: Column Labels / Headers -->
                    <div class="row align-items-start p-1 border-top" style="background-color: #e9ecef; border-top: 2px solid #5e5e5e !important;">
                      <div class="d-flex align-items-end flex-wrap" style="gap: 10px;">
                        <!-- Section 1 -->
                        <div class="d-flex flex-column">
                          <label class="mb-0 font-weight-bold text-danger" style="font-size: 11px; width: 130px;">VESSEL</label>
                        </div>
                        <div class="d-flex flex-column">
                          <label class="mb-0 font-weight-bold text-danger" style="font-size: 11px; width: 110px;">JOB COMPLETION</label>
                        </div>
                        <div class="d-flex flex-column">
                          <label class="mb-0 font-weight-bold text-danger" style="font-size: 11px; width: 149px;">ACKNOWLEDGEMENT</label>
                        </div>
                      </div>

                      <div class="d-flex align-items-end flex-wrap pl-5">
                        <!-- Section 2 -->
                        <div class="d-flex flex-column">
                          <label class="mb-0 font-weight-bold text-danger" style="font-size: 11px; width: 130px;">VESSEL</label>
                        </div>
                        <div class="d-flex flex-column">
                          <label class="mb-0 font-weight-bold text-danger" style="font-size: 11px; width: 150px;">JOB COMPLETION</label>
                        </div>
                        <div class="d-flex flex-column">
                          <label class="mb-0 font-weight-bold text-danger" style="font-size: 11px; width: 130px;">ACKNOWLEDGEMENT</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <template v-if="!isLoadingInstructionVessel && filteredPscInstructionVessels.length > 0">
                    <div class="col-6 mb-1" v-for="vessel in filteredPscInstructionVessels ">
                      <div class="row" style="margin-right: 0 !important;" :class="[{'bg-d2eaff':selectedChangeAcknowledgement.some(val => val.id === vessel.id)}]">
                        <div class="col-4 align-self-center">
                          <div class="row align-items-center">
                            <font-awesome-icon icon="ship" /> {{vessel.vessel | toUpper}}
                          </div>
                        </div>
                        <div class="col-3 align-self-center pl-0">
                            <span class="font-weight-bolder" :class="{
                            'text-danger':vessel.cancelled_at,
                            'text-574e4e':!vessel.cancelled_at && vessel.job_status_id ==1,
                            'text-056cb4':!vessel.cancelled_at && vessel.job_status_id ==2,
                            'text-42b983':!vessel.cancelled_at && vessel.job_status_id ==3,
                            }">{{ vessel.cancelled_at ? 'CANCELLED' : vessel.job_status | toUpper }}
                            </span>
                        </div>
                        <div class="col-3 align-self-center" :class="isEditCompanyInstructionStatus? 'pl-0':(vessel.cancelled_at? 'pl-0':'pl-4')">
                            <select v-if="isEditCompanyInstructionStatus && !vessel.cancelled_at" class="form-control form-control-sm text-center" style="width: 127px;padding-left:0; font-size: 11px;" @change="selectedAcknowledgementStatus(vessel, $event)">
                              <option style="font-size: 12px;" :value="ackStatus.id" v-for="ackStatus in acknowledgementStatuses" :selected="ackStatus.id === (selectedChangeAcknowledgement.find(v => v.id === vessel.id)?.update_acknowledgement_status_id?? vessel.acknowledgement_status_id)">{{ackStatus.name}}</option>
                            </select>
                            <span v-else class="font-weight-bolder" :class="{
                                'text-danger':vessel.cancelled_at,
                                'text-4c4c4c':!vessel.cancelled_at && vessel.acknowledgement_status_id ==1,
                                'text-042454':!vessel.cancelled_at && vessel.acknowledgement_status_id == 2,
                                'text-42b983':!vessel.cancelled_at && vessel.acknowledgement_status_id == 3,
                                'text-1b4f72':!vessel.cancelled_at && vessel.acknowledgement_status_id == 4,
                              }">
                            {{vessel.cancelled_at ? 'CANCELLED' : vessel.acknowledgement_status | toUpper }}
                          </span>
                        </div>
                        <div class="col-1">
                          <button type="button" title="View Instruction" class="e-btn e-btn-blue btn-xs" @click="viewVesselResponse(vessel,false)">
                            <font-awesome-icon icon="eye" class="force-white-all" /> <small class="text-white">View</small>
                          </button>
                        </div>
                        <div class="col-1 align-self-center">
                          <button type="button" title="View Instruction in New Tab" class="e-btn e-btn-blue btn-xs" @click="viewVesselResponse(vessel,true)">
                            <font-awesome-icon icon="share" class="force-white-all" /> <small class="text-white">View</small>
                          </button>
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="!isLoadingInstructionVessel && filteredPscInstructionVessels.length <= 0">
                    <div class="col-12 mb-1">
                      <div class="row">
                        <div class="col-12">
                          No records found
                        </div>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="col-12 mb-1">
                      <div class="row">
                        <div class="col-12">
                          <loading></loading>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="row align-items-center mb-3">
              <div class="col-2">
                <h6 class="font-weight-bold">Instruction Attachments</h6>
              </div>
              <div class="col-lg-10 text-left">
                <div class="row">
                  <div class="col-2"  v-for="attachment in instructionFiles">
                    <other-comp :no-delete="true"
                                @viewOther="viewInstructionAttachment(attachment,false)"
                                :attachment="attachment" attachment-name="name" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-2">
                <h6 class="font-weight-bold">Job Done</h6>
              </div>
              <div class="col-lg-10 text-left">
                <template v-if="!!instruction.vessel">

                  <vue-editor v-if="!instruction.vessel.cancelled_at" :editor-toolbar="toolbar" v-model="instruction.vessel.response"></vue-editor>
                  <div id="textArea"  v-else  class="pre-wrap-txt textarea-display-card"  v-html="instruction.vessel.response || '' " />
                </template>
              </div>
            </div>

            <div class="row align-items-center mb-3">
              <div class="col-2">
                <h6 class="font-weight-bold">Attachments</h6>
              </div>
              <div class="col-lg-10 text-left">
                <template v-if="!!instruction.vessel">
                  <div class="row justify-content-start mr-1 mb-2 mt-1"  v-if="!instruction.vessel.cancelled_at">
                    <template v-if="!isEditAttachments">
                      <div class="ml-2 p-2">
                        {{ instructionAttachments.length > 0 ? '' : '(No uploaded file(s) yet)'}}
                      </div>
                      <button class="e-btn e-btn-green" @click="addEditAttachments" id="addBtn" type="button">{{ instructionAttachments.length > 0 ? 'Edit Attachments' : 'Add Attachments'}}</button>
                    </template>
                    <template v-else >
                      <div class="ml-2">
                        <button class="e-btn e-btn-outlined-red ml-2" type="button" @click="cancelEditAttachment">Cancel</button>
                        <button class="e-btn e-btn-blue ml-2" type="submit" @click.prevent="saveAttachments" :class="is_attachments_change === false ? 'e-btn-blue-disabled' : ''" :disabled="is_attachments_change === false">Save</button>
                      </div>
                    </template>
                  </div>
                </template>

                <div class="row mb-2 mr-2 ml-1" style="display: block">
                  <div>
                    <attachments-handler
                      ref="ci-documents-handler"
                      :accepted-file-types="mimes"
                      :current-attachments="documentAttachments"
                      :edit-mode="isEditAttachments"
                      :viewing-permission="true"
                      :deleting-permission="true"
                      :changes_id="'is_attachments_change'"
                      @attachment-has-changes="setButtonChange"
                      :max-height="500"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row align-items-center mb-2">
              <div class="col-lg-2">
                <h6 class="font-weight-bold">Job Status</h6>
              </div>
              <div class="col-lg-4">
                <template v-if="!!instruction.vessel">
                  <select class="form-control form-control-sm" :disabled="instruction.vessel.cancelled_at" v-model="instruction.vessel.job_status_id">
                    <option :value="status.id" v-for="status in jobStatuses">
                      {{status.name | toUpper}}
                    </option>
                  </select>
                </template>
              </div>
            </div>
            <template v-if="!!instruction.vessel">
              <div class="row align-items-center mb-2">
                <div class="col-lg-2">
                  <h6 class="font-weight-bold">Acknowledgement Status</h6>
                </div>
                <div class="col-lg-4">
                  <select class="form-control form-control-sm" disabled v-model="instruction.vessel.acknowledgement_status_id">
                    <option :value="status.id" v-for="status in acknowledgementStatuses">
                      {{status.name | toUpper}}
                    </option>
                  </select>
                </div>
              </div>
            </template>
            <div class="row align-items-center mb-2">
              <div class="col-lg-2">
                <h6 class="font-weight-bold">Comments</h6>
              </div>
              <div class="col-lg-10">
               <CIComment v-if="!!instruction.vessel" :ciVesselId="instruction.vessel.id" :vessel-response="instruction.vessel"></CIComment>
              </div>
            </div>
            <div class="modal-footer">
                <button class="e-btn e-btn-green e-btn-lg" type="button" v-show="!!instruction.vessel && !instruction.vessel.cancelled_at && isVesselResponseModified" @click="sendResponse">Submit</button>
            </div>
          </template>
        </form>
      </template>
    </CIModal>
    <CIModal id="view-vessel-response" :key="'view-vessel-response'">
      <template v-slot:header>
        <template v-if="!!vesselResponse">
          <h5 class="font-weight-bold">Vessel Response : {{vesselResponse.vessel | toUpper}}</h5>
        </template>
        <button type="button" class="close" @click="resetVesselResponse('view-vessel-response',true)">
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <template v-slot:body>
        <div class="row align-items-center mb-2">
          <div class="col-lg-2">
            <h6 class="font-weight-bold">Job Completion:</h6>
          </div>
          <div class="col-lg-4">
            <template v-if="vesselResponse">
              <select class="form-control form-control-sm" v-model="vesselResponse.job_status_id"
                      name="job-status" id="job-status" disabled>
                <option :value="jobStatus.id" v-for="jobStatus in jobStatuses">{{jobStatus.name}}</option>
              </select>
            </template>
          </div>
        </div>
        <div class="row align-items-center mb-2">
          <div class="col-lg-2">
            <h6 class="font-weight-bold">Job Done:</h6>
          </div>
          <div class="col-lg-10">
            <template v-if="!!vesselResponse">
              <div id="textArea" class="pre-wrap-txt textarea-display-card" v-html="vesselResponse.response || '' "/>
            </template>
          </div>
        </div>
        <div class="row align-items-center mb-2">
          <div class="col-lg-2">
            <h6 class="font-weight-bold">Attachments:</h6>
          </div>
          <div class="col-lg-10">
            <div class="row mb-2">
              <div class="col-2"  v-for="attachment in instructionAttachments">
                <other-comp :no-delete="true"
                            @viewOther="viewInstructionAttachment(attachment,true)"
                            :attachment="attachment" attachment-name="name" />
              </div>
            </div>
          </div>
        </div>

        <div class="row align-items-center mb-2">
          <div class="col-lg-2">
            <h6 class="font-weight-bold">Acknowledgement:</h6>
          </div>
          <div class="col-lg-5" v-if="true">
            <div class="row">
              <div class="col-auto">
                <template v-if="$route.query.type === 'rs'">
                  <template v-if="user.is_vessel === false">
                    <div class="row">
                      <template v-if="!!vesselResponse">
                        <div class="col-auto">
                          <template v-if="isAllowed('rightship.main.risq-findings.main.company-instruction.edit-acknowledgment-status') === false">
                            {{ acknowledgementStatuses.length > 0 ? acknowledgementStatuses.filter(status => status.id === vesselResponse?.acknowledgement_status_id)[0]?.name : '' }}
                          </template>
                          <template v-else>
                            <select disabled class="form-control form-control-sm"  :disabled="vesselResponse.cancelled_at" v-model="vesselResponse.acknowledgement_status_id"
                                    name="job-status" id="job-status">
                              <option :value="ackStatus.id" v-for="ackStatus in acknowledgementStatuses">{{ackStatus.name}}</option>
                            </select>
                          </template>

                        </div>
                        <template v-if="isAllowed('rightship.main.risq-findings.main.company-instruction.edit-acknowledgment-status') === true">
                          <div class="col-auto" v-show="isVesselResponseModified">
                            <button class="btn btn-sm btn-success" :disabled="vesselResponse.cancelled_at" @click.prevent="sendAcknowledgementStatus">
                              SAVE
                            </button>
                          </div>
                        </template>
                      </template>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <template v-if="$route.query.type !== 'ia_oe'">
                    <div class="row">
                      <template v-if="!!vesselResponse">
                        <div class="col-auto">
                          <template>
                            <select disabled class="form-control form-control-sm"  :disabled="vesselResponse.cancelled_at" v-model="vesselResponse.acknowledgement_status_id"
                                    name="job-status" id="job-status">
                              <option :value="ackStatus.id" v-for="ackStatus in acknowledgementStatuses">{{ackStatus.name}}</option>
                            </select>
                          </template>
                        </div>
                        <div class="col-auto" v-show="isVesselResponseModified">
                          <button class="btn btn-sm btn-success" :disabled="vesselResponse.cancelled_at" @click.prevent="sendAcknowledgementStatus">
                            SAVE
                          </button>
                        </div>
                      </template>
                    </div>
                  </template>
                  <template v-if="$route.query.type === 'ia_oe'">
                    <template v-if="user.is_vessel === false">
                      <div class="row">
                        <template v-if="!!vesselResponse">
                          <div class="col-auto">
                            <template v-if="isAllowed('vessel-ia.appointment.non-conformity.objective-evidence.ci.edit-acknowledgment-status') === false">
                              {{ acknowledgementStatuses.length > 0 ? acknowledgementStatuses.filter(status => status.id === vesselResponse?.acknowledgement_status_id)[0]?.name : '' }}
                            </template>
                            <template v-else>
                              <select disabled class="form-control form-control-sm"  :disabled="vesselResponse.cancelled_at" v-model="vesselResponse.acknowledgement_status_id"
                                      name="job-status" id="job-status">
                                <option :value="ackStatus.id" v-for="ackStatus in acknowledgementStatuses">{{ackStatus.name}}</option>
                              </select>
                            </template>

                          </div>
                          <template v-if="isAllowed('vessel-ia.appointment.non-conformity.objective-evidence.ci.edit-acknowledgment-status') === true">
                            <div class="col-auto" v-show="isVesselResponseModified">
                              <button class="btn btn-sm btn-success" :disabled="vesselResponse.cancelled_at" @click.prevent="sendAcknowledgementStatus">
                                SAVE
                              </button>
                            </div>
                          </template>
                        </template>
                      </div>
                    </template>
                  </template>
                </template>

              </div>
            </div>
          </div>

        </div>

        <div class="row align-items-center mb-2">
          <div class="col-lg-2">
            <h6 class="font-weight-bold">Acknowlegement Status Updated By:</h6>
          </div>
          <div class="col-lg-5 text-left">
            <span class="p">{{vesselResponse.ack_status_updated_by | toUpper}}</span>
          </div>
        </div>

        <div class="row align-items-center mb-2">
          <div class="col-lg-2">
            <h6 class="font-weight-bold">Comments:</h6>
          </div>
          <div class="col-lg-10">
            <template v-if="!!vesselResponse">
              <CIComment :key="vesselResponse.id" :vessel-response="vesselResponse" v-if="!!vesselResponse.id" :ciVesselId="vesselResponse.id"></CIComment>
            </template>
          </div>
        </div>
      </template>

    </CIModal>
  </div>
</template>

<script>
import CompanyInstructionSubTree from "./CompanyInstructionSubTree.vue";
import CIModal from "../../ci/CIModal.vue";
import {mapActions, mapGetters} from "vuex";
import {AlertService} from "../../../../services/AlertService";
import OtherComp from "../../../elements/OtherComp.vue";
import axios from "axios";
import {CI_INDEX, CI_VESSEL_INDEX} from "../../../../services/ConstantService";
import {FileService} from "../../../../services/FileService";
import CIComment from "../../ci/CIComment.vue";
import ObjectMixin from "@/mixins/ObjectMixin";
import {permissionMixin} from "@/mixins/permissionMixins";
import AttachmentsHandler from "@/components/common/AttachmentsHandler.vue";
import TableColumnSearch from "@/components/common/TableColumnSearch.vue";
import AppLoading from "@/components/elements/AppLoading";
import _ from 'lodash';

export default {
  name: "CompanyInstructionTree",
  components: {TableColumnSearch, AttachmentsHandler, CIComment, OtherComp, CIModal, CompanyInstructionSubTree, 'loading': AppLoading},
  props: {
    company_instructions: {
      type: Object | Array,
      default: null,
    }
  },
  mixins:[ObjectMixin, permissionMixin],
  data() {
    return {
      activetrees: [],
      showInfo:true,
      isEditAttachments:false,
      is_attachments_change : false,
      instruction: {},
      vessels:[],
      isVesselResponseModified:false,
      toolbar: [
        ['bold', 'italic', 'strike', 'underline'],
        [{
          'color': ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff",
            "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff",
            "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff",
            "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2",
            "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"]
        }]
      ],
      vesselResponse:{},
      tempVesselResponse:{},
      isEditCompanyInstructionStatus:false,
      isLoadingInstructionVessel:false,
      filters:{
        vessel: '',
        job: null,
        acknowledgement: null,
      },
      debouncedVesselFilter: {
        vessel: '',
        job: null,
        acknowledgement: null,
      },
      selectedChangeAcknowledgement: [],
      mimes: [
        'application/pdf',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/zip',
        'application/octet-stream',
        'application/x-zip-compressed',
        'multipart/x-zip',
        'image/apng',
        'image/avif',
        'image/gif',
        'image/jpeg',
        'image/png',
        'image/svg+xml',
        'image/webp',
        'image/jpg',
        'image/tiff'
      ]
    }
  },
  computed:{
    ...mapGetters(['user','jobStatuses','acknowledgementStatuses','instructionAttachments','instructionFiles', "CIactivetrees", 'openedCompanyInstruction']),
    documentAttachments() {
      return this.instructionAttachments.map(document => {
        return {
          source : document.path,
          options : {
            type : 'local',
            file : {
              name : document.name,
              type : document.mime_type,
              size: parseFloat(document.file_size.replace(/[^0-9.,]/g, '').replace(/,/g, '')) * 1000
            },
            metadata : {
              id : document.id,
              referencable_id : document.referencable_id,
              thumbnail : document.thumbnail,
              file_size : document.file_size,
              created_at : document.created_at,
              view_attachment_method : () => this.viewInstructionAttachment(document)
            }
          }
        }
      })
    },
    filteredPscInstructionVessels() {
      if (!this.instruction?.vessels) {
        return [];
      }

      const vesselSearchKeyword = this.debouncedVesselFilter?.vessel?.toLowerCase() || '';
      const jobSearchKeyword = this.debouncedVesselFilter?.job;
      const acknowledgementSearchKeyword = this.debouncedVesselFilter?.acknowledgement;

      return this.instruction.vessels.filter(vessel => {

        const matchesVessel = !vesselSearchKeyword ||
          vessel?.vessel?.toLowerCase().includes(vesselSearchKeyword);

        let matchesJob = true;
        if (jobSearchKeyword === 'cancelled') {
          matchesJob = vessel?.cancelled_at !== null;
        } else if (jobSearchKeyword) {
          matchesJob = vessel?.job_status_id == jobSearchKeyword && vessel?.cancelled_at === null;
        }

        let matchesAcknowledgement = true;
        if (acknowledgementSearchKeyword === 'cancelled') {
          matchesAcknowledgement = vessel?.cancelled_at !== null;
        } else if (acknowledgementSearchKeyword) {
          matchesAcknowledgement = vessel?.acknowledgement_status_id == acknowledgementSearchKeyword && (vessel?.cancelled_at === null || vessel?.cancelled_at === undefined);
        }

        return matchesVessel && matchesJob && matchesAcknowledgement;
      });
    },
  },
  created() {
    this.company_instruction_list = this.company_instructions
    this.updateInstructionVesselFilter = _.debounce((value, type) => {
      if(type === 'vessel'){
        this.debouncedVesselFilter.vessel = value;
      }else if(type === 'job'){
        this.debouncedVesselFilter.job = value;
      }else if(type === 'acknowledgement'){
        this.debouncedVesselFilter.acknowledgement = value;
      }

      this.isLoadingInstructionVessel = false
    }, 500);
  },
  beforeDestroy() {
    this.updateInstructionVesselFilter.cancel();
  },
  methods:{
    ...mapActions([
      'sendVesselResponse',
      'bulkSendVesselResponse',
      'addNewVesselAttachments',
      'getVesselAttachments',
      'deleteCiVesselAttachment',
      'getCompanyInstructionAttachments'
    ]),

    redirectTree(instruction){
      if(this.$route.query.type === 'ia_oe'){
        const route= this.$router.resolve(
          {
              name: 'IaCompanyInstructions',
              params: {
                vessel_id : instruction.vessel_id,
                id: instruction.audit_record_id,
                type : instruction.type,
                ncr_id : instruction.ncr_id,
                ncr_type : instruction.ncr_type,
                oe_id : instruction.id,
              },
            },
          )
          window.open(route.href,'_blank');

      } else {
        const route = this.$router.resolve({
            name: this.$route.query.type === 'air'
              ? 'AccidentIncidentReport'
              : (this.$route.query.type === 'psc'
                ? 'PscMain'
                : 'RsMain'),
            params: {id: instruction.id},
          });
          window.open(route.href, '_blank');
        }
    },

    resetPscCompanyInstructionFilter(){
      // this.$refs.vesselSearch.resetValue()
      this.filters.vessel = ''
      this.filters.job = null
      this.filters.acknowledgement = null

      this.debouncedVesselFilter.vessel = ''
      this.debouncedVesselFilter.job = null
      this.debouncedVesselFilter.acknowledgement = null
    },

    formatOptionName(name) {
      if (!name) return '';
      if (name.toUpperCase() === 'DEFICIENCY NOTED') {
        return 'DEF. NOTED';
      }
      return name;
    },

    selectedAcknowledgementStatus(data, event) {
      const selectedAcknowledgementStatus = parseInt(event.target.value)
      const res = this.instruction.vessels.find(vessel => vessel.id === data.id)

      if(res?.acknowledgement_status_id !== selectedAcknowledgementStatus){
        this.selectedChangeAcknowledgement.push({...data, update_acknowledgement_status_id: selectedAcknowledgementStatus})

      }else{
        this.selectedChangeAcknowledgement = this.selectedChangeAcknowledgement.filter(vessel => vessel.id !== res.id)
      }
    },

    cancelEditAcknowledgementStatus(){
      this.selectedChangeAcknowledgement = []
      this.isEditCompanyInstructionStatus = false
    },

    resetInstruction(){
      this.instruction= {}
      this.vessels=[]
      $('#view-instruction').modal('hide')
      this.$store.commit('SET_COMPANY_INSTRUCTION_COMMENTS',[])
      this.$emit('resetCompanyInstruction')
    },
    viewInstruction(event){
      this.instruction=event

      let openedInstruction = this.instruction;
      openedInstruction.vessel_id = this.instruction.vessel_audit_id;
      this.$store.commit('SET_OPENED_COMPANY_INSTRUCTION', this.instruction);
      this.vessels=event.vessels.map(vessel=>vessel.vessel_id)
      if(this.user.vessel_id){
        this.tempVesselResponse=Object.assign({},this?.instruction?.vessel)
        this.getVesselAttachments({id:this.instruction.vessel.id});
      }
      this.getCompanyInstructionAttachments({id:this.instruction.id})
      this.$nextTick().then(()=>{
        $('#view-instruction').modal('show')
      })
    },

    resetVesselResponse() {
      this.vesselResponse={}
      $('#view-vessel-response').modal('hide')

      $('#view-instruction').css({
        zIndex : 1050
      });
    },

    viewVesselResponse(vessel,newTab = false){
      if(newTab){
        var w = window.window.innerWidth + 100;
        var h= window.window.innerHeight + 100;
        const route = this.$router.resolve(
          {
            name: 'StaffVesselResponse',
            query:{
              id:vessel.id
            }
          },
        )
        window.open(route.href, '_blank',`toolbar=yes,scrollbars=yes,resizable=yes,width=${w},height=${h}`)
      }
      else {
        this.tempVesselResponse=Object.assign({},vessel)
        this.vesselResponse=Object.assign({},vessel)
        this.getVesselAttachments({id:vessel.id});
        this.$nextTick().then(()=>{
          $('#view-vessel-response').modal('show')
        })

        $('#view-instruction').css({
          zIndex : 1040
        });
      }
    },
    async sendResponse(){
      if(await AlertService.confirmUpdateAlert()){
        const vesselParams={
          id:this.instruction.vessel.id,
          job_status_id:this.instruction.vessel.job_status_id,
          response:this.instruction.vessel.response
        }
        const response =await this.sendVesselResponse(vesselParams)
        if(response) {
          AlertService.successAlert('Vessel Response Updated Successfully','Send Response')
          this.instruction={}
          $('#view-instruction').modal('hide')
          this.$emit('sendResponse')
        }
      }
    },

    async sendAcknowledgementStatus(){
      if(await AlertService.confirmUpdateAlert()){
        const vesselParams={
          id:this.vesselResponse.id,
          acknowledgement_status_id:this.vesselResponse.acknowledgement_status_id,
        }
        const response =await this.sendVesselResponse(vesselParams)
        if(response) {
          AlertService.successAlert('Acknowledgement Status Updated Successfully','Send Acknowledgement Status')
          this.instruction=Object.assign({},response)
          const vessel=this.instruction.vessels.find(item=>item.id==this.vesselResponse.id);
          this.vesselResponse=Object.assign({},vessel)
          this.tempVesselResponse=Object.assign({},vessel)
          this.isVesselResponseModified=false;
          this.$emit('sendResponse')
        }
      }
    },
    async bulkSendAcknowledgementStatus(){
      if(await AlertService.confirmUpdateAlert()){

        swal.fire({
          'title':`Updating Acknowledgement Statuses <br> Please wait.....`
        })

        swal.showLoading();
        const params = this.selectedChangeAcknowledgement.map(vessel => {
          return {
            'id': vessel?.id,
            'acknowledgement_status_id': vessel?.update_acknowledgement_status_id
          }
        })

        const response =await this.bulkSendVesselResponse({vessels: params})
        if(response) {
          AlertService.successAlert('Statuses Updated','All selected acknowledgment statuses have been updated successfully.')
          this.selectedChangeAcknowledgement = []
          this.isEditCompanyInstructionStatus = false

          this.instruction=Object.assign({},response)

          this.$emit('sendResponse')
        }
      }
    },
    async saveAttachments(){
      if (this.$refs["ci-documents-handler"].isProcessingFiles() === true) {
        return AlertService.warningAlert(`Please wait for the attachments to finish processing`, 'ATTACHMENTS PROCESSING');
      }

      const filesHasError = this.$refs["ci-documents-handler"].filesHasError();
      if (filesHasError) {
        return;
      }

      swal.fire({
        'title':`Updating Attachments <br> Please wait.....`
      })

      swal.showLoading();

      // saving of files process
      const files = this.$refs["ci-documents-handler"].getValidFilesUniqueIds();

      if (files.length > 0) {
        let formData = new FormData();
        Array.prototype.forEach.call(files, file => {
          formData.append('file_unique_ids[]', file);
        })

        formData.append('id',this.instruction.vessel.id);
        await this.addNewVesselAttachments(formData)
      }

      const filesToRemove = this.$refs["ci-documents-handler"].getFilesToRemove();
      // deletion of files process
      this.$refs["ci-documents-handler"].resetValues();
      await this.deleteAllAttachments(filesToRemove);

      await this.getVesselAttachments({id:this.instruction.vessel.id});
      swal.close();
      await AlertService.successAlert(`Attachments updated successfully`, 'UPLOAD ATTACHMENTS');
      this.isEditAttachments = false;
    },
    async deleteAllAttachments(filesToRemove, counter = 0) {
      if (filesToRemove.length === 0) {
        return;
      }
      await this.deleteCiVesselAttachment({
        id : filesToRemove[counter].referencable_id,
        attachment_id : filesToRemove[counter].id
      });
      counter++;
      if (counter < filesToRemove.length) {
        await this.deleteAllAttachments(filesToRemove, counter);
      }
    },
    async cancelEditAttachment(){
      if (this.is_attachments_change === false) {
        this.$refs["ci-documents-handler"].resetValues();
        this.isEditAttachments=false;
      } else {
        if(await AlertService.cancelAlert()) {
          this.$refs["ci-documents-handler"].resetValues();
          this.is_attachments_change = false;
          this.isEditAttachments=false;
        }
      }
    },
    async viewInstructionAttachment(attachment,fromVessel=true) {
      swal.fire({
        title: 'Please wait',
      });
      swal.showLoading();

      const mainRoute= fromVessel ? CI_VESSEL_INDEX : CI_INDEX

      const url= [mainRoute,attachment.referencable_id,'attachment',attachment.id].join('/')

      const response = await axios.get(url ,{responseType: 'blob'})

      if (response && response.status == 200) {
        if (attachment.extension === 'pdf' || attachment.mime_type.includes("image")) {
          await FileService.viewDocument(response.data,attachment)
        }
        else {
          await FileService.downloadDocument(response.data,attachment,'name');
        }
        swal.close();
      }
      else {
        AlertService.errorAlert('File not exists',"View Vessel Attachment")
      }
    },
    async confirmDeleteAttachment(attachment) {
      if(await AlertService.confirmDeleteAlert('DELETE VESSEL ATTACHMENT','Do you want to delete attachment ?','Yes Proceed')){
        const response = this.deleteCiVesselAttachment({id:attachment.referencable_id,attachment_id:attachment.id});
        if(response) {
          AlertService.successAlert('Attachment deleted Successfully','Delete Attachments')
        }
      }
    },
    toggleAccordion(index) {
      if (this.activetrees.includes(index)) {
        this.activetrees = this.activetrees.filter(i => i !== index);
      } else {
        this.activetrees.push(index);
      }
      this.$store.commit('SET_ACTIVE_TREES',this.activetrees)
    },
    setButtonChange(changeId, hasChanges) {
      this[changeId] = hasChanges;
    },
    async setVesselsToTable() {
      this.updateInstructionVesselFilter.cancel();
      this.debouncedVesselFilter.vessel = this.filters.vessel;
    },
    addEditAttachments() {
      this.isEditAttachments = !this.isEditAttachments;
      this.$refs["ci-documents-handler"].resetValues();
    }
  },
  watch:{
    'instruction.vessel.job_status_id'(){
      this.isVesselResponseModified=this.dataDiff(this?.tempVesselResponse ?? null,this?.instruction?.vessel ?? null)
    },
    'instruction.vessel.response'(){
      this.isVesselResponseModified=this.dataDiff(this?.tempVesselResponse ?? null,this?.instruction?.vessel ?? null)
    },
    'vesselResponse.acknowledgement_status_id'(){
      this.isVesselResponseModified=this.dataDiff(this?.tempVesselResponse ?? null,this.vesselResponse ?? null)
    },
    'filters.vessel'(newValue) {
      this.isLoadingInstructionVessel = true
      this.updateInstructionVesselFilter(newValue, 'vessel');
    },
    'filters.job'(newValue) {
      this.isLoadingInstructionVessel = true
      this.updateInstructionVesselFilter(newValue, 'job');
    },
    'filters.acknowledgement'(newValue) {
      this.isLoadingInstructionVessel = true
      this.updateInstructionVesselFilter(newValue, 'acknowledgement');
    }

  }
}

</script>
<style scoped>
.checker {
  height: 0px;
}


td:nth-child(2),
td:nth-child(3) {
  width: 10%;
}

td:nth-child(5),
td:nth-child(6),
td:nth-child(7) {
  width: 7%;
}
#exampleModalLongTitle:hover {
  text-decoration: none;
}

.bg-d2eaff {
  background-color: #d2eaff !important;
}
</style>
